<template>
    <div data-spy="scroll" data-target=".nav-menu" data-offset="50">
        <!-- Page Loader -->
        <div id="pageloader" v-show="isLoading">            
            <div class="loader-item">
                <img
                    src="../../public/new-assets/images/loading.gif"
                    alt="loader"
                />
            </div>
        </div>
        <!-- End Page Loader -->

        <!-- Navigation Section -->
        <div style="min-height: 80px">
            <Navbar />
        </div>
        <!-- End Navigation Section -->

        <!-- Container Section  -->
        <div
            class="flex-container d-flex"
            style="display: flex"
            v-if="!isLoading"
        >
            <!-- Left Sidebar -->
            <Sidebar />
            <!-- End Left Sidebar -->

            <!-- Right Content -->
            <div class="right-container" :class="{'visibleOverFlow' : isVisibleOverFlow}" style="width: 100%">
                <router-view @visibleOverFlow="visibleOverFlow"></router-view>
            </div>
            <!-- End Right Content -->
        </div>
        <!-- End Container Section -->

        <!-- Footer Section -->
        <Footer />
        <!-- End Footer Section -->

        <!-- Back To Top Button -->
        <section id="back-top">
            <a href="#home" class="scroll"></a>
        </section>
        <!-- End Back To Top Button -->
    </div>
</template>

<style lang="scss">
@import url("https://cdn.datatables.net/1.12.0/css/jquery.dataTables.min.css");
@import "../../public/new-assets/css/reset";
@import "../../public/new-assets/css/animate.min";
@import "../../public/new-assets/css/bootstrap";
@import "../../public/new-assets/css/style";
@import "../../public/new-assets/css/flexslider";
@import "../../public/new-assets/css/font-awesome";
@import "../../public/new-assets/css/owl.carousel";
@import "../../public/new-assets/css/settings";
@import "../../public/new-assets/css/prettyPhoto";
@import "../../public/new-assets/css/responsive";
@import "../../public/new-assets/css/player/YTPlayer";
@import "../../public/new-assets/css/style-agenda";
@import "../../public/new-assets/css/site.gallery";

.visibleOverFlow {
    overflow: visible !important;
}
.my-link {
    color: #2980b9;
    text-decoration: underline;
    &:hover {
        color: #2980b9;
    }
}
.p-0 {
    padding: 0;
}
.py-4 {
    padding-top: 2rem;
    padding-bottom: 2rem;
}
.m-0 {
    margin: 0;
}
.mt-3 {
    margin-top: 3rem;
}
.ml-4 {
    margin-left: 2rem;
}
.mb-4 {
    margin-bottom: 2rem;
}
.font-italic {
    font-style: italic;
}
.text-underline {
    text-decoration: underline;
}
</style>

<script>
$().ready(function () {
    $('a[href$="' + window.location.pathname + '"]')
        .parent()
        .attr("class", "navigation-item current");

    $("#companies-table").DataTable({
        ajax: "assets/js/datatables/ds.json",
        columnDefs: [
            { width: "30%", targets: [0] },
            { width: "15%", targets: [1, 4] },
        ],
    });

    $(".reammorebtn").click(function () {
        var _this = $(this);
        var dots = _this.parent().find("#dots");
        var moreText = _this.parent().find("#more");

        if (dots.hasClass("hidden")) {
            dots.removeClass("hidden");
            _this.html("Read more");
            moreText.addClass("hidden");
        } else {
            dots.addClass("hidden");
            _this.html("Read less");
            moreText.removeClass("hidden");
        }
    });

    $(window).scroll(function () {
        if ($(window).scrollTop() >= 330) {
            $(".sticky").addClass("fixed");
        } else {
            $(".sticky").removeClass("fixed");
        }
    });

    $("#collapseSchedule,#collapseExample,#collapseCompanies").on(
        "hidden.bs.collapse",
        function () {
            $(this).parent().find("i").removeClass("fa-arrow-circle-down");
            $(this).parent().find("i").addClass("fa-arrow-circle-right");
        }
    );

    $("#collapseSchedule,#collapseExample,#collapseCompanies").on(
        "shown.bs.collapse",
        function () {
            $(this).parent().find("i").removeClass("fa-arrow-circle-right");
            $(this).parent().find("i").addClass("fa-arrow-circle-down");
        }
    );

    let _click = "touchend" in window ? "touchend" : "click";

    $(document.body).on(_click, ".mobile-menu", () => {
        $("#collapseleftcontainer").toggleClass("open");
    });
});

import Api from "@/Api";
import Navbar from "../components/layouts/Navbar.vue";
import Sidebar from "../components/subpages/Sidebar.vue";
import Footer from "../components/layouts/Footer.vue";

export default {
    data: () => ({
        isLoading: true,
        isVisibleOverFlow: false
    }),
    components: {
    Navbar,
    Sidebar,
    Footer
},
    methods: {
        getProfileData() {
            Api()
                .get(`auth/get-required-data-update-profile`)
                .then((res) => {
                    this.$store.dispatch("setProfileData", res.data);
                    this.isLoading = false;
                })
                .catch((error) => {
                    console.log(error);
                    this.$store.dispatch("endRegisrationProccess");
                });
        },
        getConferenceTextData() {
            Api()
                .get("auth/get-conference-text")
                .then((res) => {
                    this.$store.dispatch("setConferenceTextData", res.data);
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        visibleOverFlow(isVisibleOverFlow){
            this.isVisibleOverFlow = isVisibleOverFlow
        }
    },
    created() {
        this.getProfileData();
        this.getConferenceTextData();
    },
};
</script>
